<template>
  <div class="report-front-page">
    <div class="report-front-page__top-info">
      <p><i18n-t keypath="pdfReport.frontpage_name" :locale="lang" tag="strong"></i18n-t>: {{name}}</p>
      <p><i18n-t keypath="pdfReport.frontpage_date" :locale="lang" tag="strong"></i18n-t>: {{date || today}}</p>
      <p><i18n-t keypath="pdfReport.frontpage_normgroup" :locale="lang" tag="strong"></i18n-t>: {{normGroupName}}</p>
    </div>
    <h1>{{ expertReport.translatedName || ' ' }}</h1>
    <h2>{{ expertReport.translatedSubtitle || ' ' }}</h2>
    <div class="report-front-page__contents">
      <div v-for="item in (expertReport.items || [])" :key="item.id">
        <div class="report-front-page__circle">
          <div class="report-front-page__checkmark"></div>
        </div>
        <p>{{ item.title || '' }}</p>
      </div>
    </div>
    <div class="report-front-page__bottom">
      <img :src="imageUrl" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: '',
    normGroup: '',
    expertReportId: '',
    name: '',
    testMethod: '',
    testMethodSubtitle: '',
    date: '',
    optionsNormGroups: [],
    optionsExpertReports: [],
    userCompany: null,
    expertReportDetails: null
  },
  computed: {
    today() {
      return new Date().toLocaleDateString(this.lang || 'sv-SE')
    },
    normGroupName() {
      const name = this.optionsNormGroups.find(ng => ng.id === this.normGroup)
      return (name && name.name) || ''
    },
    reportName() {
      const name = this.optionsExpertReports.find(er => er.id === this.expertReportId)
      return (name && name.name) || ''
    },
    imageUrl() {
      if (this.userCompany && this.userCompany.imageUrl) {
        return this.userCompany.imageUrl
      }
      let imgSrc = ''
      try {
        imgSrc = require(`../../assets/images/psytest_logo.png`)
      } catch (error) {
        console.error(`Image not found!`)
      }
      return imgSrc
    },
    expertReport() {
      const details = (this.expertReportDetails && this.expertReportDetails.translations) || []
      const langSpecificData = details.find(d => d.languageId === this.lang)
      return langSpecificData || {}
    }
  }
}
</script>

<style scoped lang="scss">
* {
  letter-spacing: initial!important;
}
h1 {
  font-size: 42px!important;
  margin: 180px 0 10px 0!important;
  color: #3e3e3f;
  width: 420px;
}
h2 {
  font-size: 22px!important;
  margin: 0 0 20px 0!important;
  padding: 0!important;
  color: #3e3e3f;
}
p,
p strong {
  font-size: 11px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
}
.report-front-page {
  padding: 0 60px;
  max-height: 810px;
  height: 810px;

  &__top-info {
    margin-top: 30px;
    padding-top: 30px;

    &::before {
      position: absolute;
      content: '';
      z-index: -1;
      top: 0;
      left: 30px;
      width: 0;
      height: 0;
      border-bottom: 220px solid transparent;
      border-left: 535px solid #d5effb;
    }
  }
  &__contents {
    margin-top: 40px;

    & > div {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
    }
  }
  &__circle {
    position: relative;
    border-radius: 50%;
    border: 2px solid #0dbff2;
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  &__checkmark {
    position: absolute;
    transform: rotate(45deg) translate(-50%, -50%);
    left: 25%;
    top: 45%;
    height: calc(8px);
    width: calc(5px);
    border-bottom: 2px solid #0dbff2;
    border-right: 2px solid #0dbff2;
  }
  &__bottom {
    position: absolute;
    bottom: 30px;
    left: 60px;

    img {
      max-width: 120px;
      max-height: 120px;
      margin-left: -30px;
      margin-bottom: 25px;
    }

    &::before {
      position: absolute;
      content: '';
      z-index: -1;
      bottom: 0;
      left: 85px;
      width: 0;
      height: 0;
      border-top: 180px solid transparent;
      border-right: 420px solid #0dbff2;
    }
  }
}
</style>
